import styled from 'styled-components'

import { maxDevice } from '../../../../../App/Util'

export const GraphContainer = styled.div`
    align-self: center;
    width: 100%;
    height: auto;
    max-height: 40%;
`
